import * as React from "react";
import { useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  Button,
  Typography,
  TextField,
  Box,
  FormHelperText,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LoadingSvg } from "../../../utils/SvgIcons";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import Tooltip from "@mui/material/Tooltip";

import { userNameValidation } from "../../../../../validations/userInfoValidation";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: 4,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 10,
    // margin:1
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function EditUserName(props) {
  const { authUserinfo, changeUserName, checkUsernameValid } = props;
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [formValues, setFormValues] = useState({ newUsername: "" });
  const handleChangeValue = (type, value) => {
    const newValue = {};
    newValue[type] = value;
    setFormValues({ ...formValues, ...newValue });
  };

  const initialValues = {};

  const checkItemStatus = (item) => {
    switch (item) {
      case "llmmt-Loading":
        return <LoadingSvg />;
      case "llmmt-NoData":
        return (
          <Tooltip title="اطلاعاتی وارد نشده است">
            <Typography>-{"------"}</Typography>
          </Tooltip>
        );
      case "llmmt-errorLoading":
        return (
          <Tooltip title="مشکل در بار گزاری اطلاعات،لطفا دوباره تلاش کنید">
            <SyncProblemIcon color="error" />
          </Tooltip>
        );
      default:
        return item;
    }
  };

  const onSubmit = (values, props) => {
    changeUserName(values);
  };

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={userNameValidation}
        onSubmit={onSubmit}
      >
        {(props) => (
          <Form>
            <TableContainer component={Paper}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "25%" : "50%" }}
                    >
                      مشاهده اطلاعات کاربری
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ width: detectSize600px ? "75%" : "50%" }}
                    >
                      {" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام کاربری قدیم"}
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      {checkItemStatus(authUserinfo["userName"])}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell component="th" scope="row">
                      {"نام کاربری جدید"}
                    </StyledTableCell>
                    <StyledTableCell align="left" sx={{ display: "flex" }}>
                      <Box>
                        <Field
                          as={TextField}
                          size="small"
                          name="newUsername"
                          label="نام کاربری جدید"
                          placeholder="نام کاربری جدید"
                          value={formValues["newUsername"]}
                          onChange={(e) => {
                            handleChangeValue("newUsername", e.target.value);
                            props.setFieldValue("newUsername", e.target.value);
                          }}
                        />
                        <FormHelperText
                          sx={{
                            m: 0,
                            p: 0,
                            color: "#f96767",
                            textAlign: "center",
                          }}
                        >
                          <ErrorMessage name="newUsername" />
                        </FormHelperText>
                      </Box>
                      <Box>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ m: 1 }}
                          color="info"
                          onClick={() => { checkUsernameValid({ newUsername: formValues["newUsername"] }) }}
                        >
                          بررسی
                        </Button>
                      </Box>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Button
              type="submit"
              variant="contained"
              sx={{ m: 2 }}
              color="success"
            >
              ذخیره
            </Button>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
